<template>
  <div>
    <div class="sign-content">
      <el-card-title :title="title" class="card1" />
      <span
        v-if="languagezh_cn"
        style="
          color: red;
          float: left;
          transform: translate(339px, -18px);
          font-size: 12px;
        "
        >（标*为必填项）</span
      >
      <el-form
        label-width="80px"
        :rules="userFormRules"
        :model="userForm"
        ref="userFormRef1"
      >
        <el-form-item
          style="position: absolute; top: -1000; left: -1000px; opacity: 0"
        >
          <el-input type="password"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.supName')"
          label-width="350px"
          prop="supplierName"
        >
          <!--  供应商名称  -->
          <el-input
            :disabled="isDisabled"
            :placeholder="$t('page.applyUsername.inputPlc.supNameMSg')"
            v-model="userForm.supplierName"
            show-word-limit
            maxlength="100"
            v-if="localLang !== 'zh-cn'"
            @blur="changeShow()"
          ></el-input>
          <el-autocomplete
            v-if="localLang === 'zh-cn'"
            v-model="userForm.supplierName"
            :fetch-suggestions="querySearchAsync"
            :placeholder="$t('page.applyUsername.inputPlc.supNameMSg')"
            @select="handleSelect"
            :trigger-on-focus="false"
            :maxlength="100"
            @blur="changeShow()"
          >
            <!-- :disabled="isDisabled" -->
            <template slot-scope="{ item }">
              <div class="name">{{ item.name }}</div>
              <!--                <div style="font-size: 12px; color: #b4b4b4;">-->
              <!--                  <span style="width: 165px; display: inline-block">省份:{{item.base}}</span>-->
              <!--                  <span v-if="item.companyType === 1">公司类型:公司</span>-->
              <!--                  <span v-else-if="item.companyType === 2">公司类型:香港公司</span>-->
              <!--                  <span v-else-if="item.companyType === 3">公司类型:社会组织</span>-->
              <!--                  <span v-else-if="item.companyType === 4">公司类型:律所</span>-->
              <!--                  <span v-else-if="item.companyType === 5">公司类型:事业单位</span>-->
              <!--                  <span v-else-if="item.companyType === 6">公司类型:基金会</span>-->
              <!--                  </div>-->
              <!--                <div style="font-size: 12px; color: #b4b4b4;">-->
              <!--                  <span style="width: 165px; display: inline-block" >法人姓名:{{item.legalPersonName}}</span>-->
              <!--                  <span>开业时间:{{item.estiblishTime}}</span>-->
              <!--                </div>-->
              <!--                <span style="font-size: 12px; color: #b4b4b4;">注册资金:{{item.regCapital}}</span>-->
            </template>
          </el-autocomplete>
          <div v-if="isShow1 && localLang === 'zh-cn'" style="color: red">
            此供应商已在平台注册，如需取回账号密码，请提交取回申请(<a
              target="_blank"
              :href="clickUrl"
              >点此取回</a
            >)
          </div>
          <div v-if="isShow1 && localLang !== 'zh-cn'" style="color: red">
            This supplier has registered on the platform, if you need to
            retrieve the account password, please submit an application for
            retrieval(<a target="_blank" :href="clickUrl"
              >Click here to retrieve</a
            >)
          </div>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.provinces')"
          label-width="350px"
          prop="value1"
          v-if="multilingual.areaShow[localLang]"
        >
          <!--  省市地区  -->
          <el-cascader
            v-model="userForm.value1"
            :options="userForm.options"
            :props="userForm.props"
            clearable
            ref="myCascader"
            @change="handleChange"
            :placeholder="$t('page.applyUsername.inputPlc.provincesMsg')"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.isThree')"
          label-width="350px"
          prop="isThree"
          v-if="threeZ && !isGAT"
        >
          <!-- 是否三证合一 -->
          <el-radio-group v-model="userForm.isThree" @change="changeRadio">
            <el-radio :label="1" value="是">{{
              $t("page.supInfo.inputPlc.yes")
            }}</el-radio>
            <el-radio :label="0" value="否">{{
              $t("page.supInfo.inputPlc.no")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.unifyCode')"
          label-width="350px"
          v-if="isShow && !isGAT"
          prop="creditCode"
          :rules="
            !isWhite && !isHaiwaiorGAT
              ? userFormRules.creditCode
              : userFormRules.creditCode2
          "
          ref="isShowRef"
          key="isShowRef12"
        >
          <!-- 统一社会信用代码 -->
          <el-input
            :placeholder="$t('page.supInfo.inputPlc.unifyCode')"
            v-model="userForm.creditCode"
            show-word-limit
            maxlength="18"
            :disabled="!isWhite && !isHaiwaiorGAT"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.GATunifyCode')"
          label-width="350px"
          v-if="isGAT"
          prop="creditCode"
          :rules="userFormRules.GATcreditCode"
          key="isShowRef10"
          ref="isShowRef"
          class="endItem"
        >
          <!-- 港澳台统一社会信用代码 -->
          <el-input
            :placeholder="$t('page.supInfo.inputPlc.GATunifyCode')"
            v-model="userForm.creditCode"
            show-word-limit
            maxlength="75"
            class="GATcreditCode"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="营业执照号:"
          label-width="350px"
          v-if="isThreeShow && threeZ"
          prop="business"
          ref="isThreeShowRef5"
        >
          <el-input
            placeholder="请输入营业执照号"
            v-model="userForm.business"
            show-word-limit
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.framework')"
          label-width="350px"
          v-if="isThreeShow && threeZ"
          prop="organizingInstitution"
          :rules="
            languagezh_cn && !isWhite && !isHaiwaiorGAT
              ? [{ required: false }]
              : userFormRules.organizingInstitution
          "
          ref="isThreeShowRef1"
        >
          <!-- 组织机构代码 -->
          <el-input
            :placeholder="$t('page.supInfo.inputPlc.framework')"
            v-model="userForm.organizingInstitution"
            show-word-limit
            maxlength="18"
            :disabled="!isWhite && !isHaiwaiorGAT"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.organization')"
          label-width="350px"
          required
          v-if="isThreeShow && threeZ"
          class="validity"
        >
          <!-- 组织机构代码证件有效期 -->
          <el-col :span="5">
            <el-form-item prop="date3" ref="isThreeShowRef2">
              <el-date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :placeholder="$t('page.supInfo.inputPlc.chooseDate')"
                v-model="userForm.date3"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="5">
            <el-form-item prop="date4" ref="isThreeShowRef3">
              <el-date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :placeholder="$t('page.supInfo.inputPlc.chooseDate')"
                v-model="userForm.date4"
                :picker-options="pickerOptions2"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.dutyParagraph')"
          label-width="350px"
          v-if="isThreeShow && threeZ"
          prop="dutyParagraph"
          :rules="
            languagezh_cn && !isWhite && !isHaiwaiorGAT
              ? [{ required: false }]
              : userFormRules.dutyParagraph
          "
          ref="isThreeShowRef4"
        >
          <!-- 税号 -->
          <el-input
            :placeholder="$t('page.supInfo.inputPlc.dutyParagraph')"
            v-model="userForm.dutyParagraph"
            maxlength="25"
            :disabled="!isWhite && !isHaiwaiorGAT"
          ></el-input>
        </el-form-item>
        <!--<el-form-item :label="$t('page.applyUsername.contentLabel.id')" label-width="350px" prop="loginId" v-show="disabledLoginId" >     &lt;!&ndash;  登录账号  &ndash;&gt;-->
        <!--<el-input :placeholder="$t('page.applyUsername.inputPlc.idMsg')" v-model="userForm.loginId" :disabled="isDisabled"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item
          v-if="languagezh_cn"
          label="登录账号:"
          label-width="350px"
          prop="userName"
          class="userMobile"
        >
          <el-input
            placeholder="请输入登录账号"
            maxlength="50"
            v-model="userForm.userName"
            :disabled="isDisabled"
          ></el-input>
          <!--            <div class="el-block" v-if="!isLogin">-->
          <!--              <div class="slideText1" v-if="slideShow">请按住滑块，拖到最右边</div>-->
          <!--              <div class="slideText2" v-else>已验证</div>-->
          <!--              <div class="el-block-replace">&nbsp;</div>-->
          <!--              <el-slider v-model="value11" @change="sliderChange" :disabled="sliderDisabled">-->
          <!--              </el-slider>-->
          <!--            </div>-->
        </el-form-item>
      </el-form>
      <el-form
        label-width="80px"
        :rules="userFormRules"
        :model="userForm"
        ref="userFormRef3"
      >
        <el-form-item
          v-if="languagezh_cn"
          label="登录账号:"
          label-width="350px"
          prop="userName"
          class="userMobile"
        >
          <el-input
            placeholder="请输入登录账号"
            maxlength="50"
            v-model="userForm.userName"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-else
          label="Username:"
          label-width="350px"
          prop="userName"
          class="userMobile"
        >
          <el-input
            placeholder="Please enter your username"
            autocomplete="off"
            v-model="userForm.userName"
            maxlength="50"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.pwd')"
          label-width="350px"
          prop="password"
          ref="passwordRef"
        >
          <!--  密码  -->
          <el-input
            @click="readonly = true"
            :readonly="readonly"
            show-password
            :placeholder="$t('page.applyUsername.inputPlc.pwdMsg')"
            v-model="userForm.password"
            autocomplete="new-password"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.repwd')"
          label-width="350px"
          prop="rePassword"
        >
          <!--  重复输入密码  -->
          <el-input
            :data-aa="isDisabled"
            show-password
            :placeholder="$t('page.applyUsername.inputPlc.repwdMsg')"
            v-model="userForm.rePassword"
            autocomplete="new-password"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </el-form>

      <el-form
        label-width="80px"
        :model="linkmanForm"
        :rules="linkmanFormRules"
        ref="userFormRef2"
        style="height: 466px"
        :class="{ enForm: !languagezh_cn }"
      >
        <!-- 推荐单位 -->
        <div class="recommendUnitGroup">
          <el-card-title
            :title="title2"
            class="card3"
            :class="{ encard: !languagezh_cn }"
          />
          <!--      <recommendUnits></recommendUnits>-->
          <div :class="multilingual.reCompanyTitleClass[localLang]">
            {{ $t("page.applyUsername.contentTitles.reCompanyMsg") }}
          </div>
          <el-form-item
            :label="$t('page.applyUsername.contentLabel.reCompany')"
            label-width="350px"
            prop="reCompany"
            class="reCompany"
          >
            <el-input
              :placeholder="$t('page.applyUsername.inputPlc.reCompanyMsg')"
              v-model.trim="linkmanForm.reCompany"
              @focus="$refs.choosePartyA.showDialogInventory()"
              :readonly="true"
              clearable
            ></el-input>
          </el-form-item>
        </div>

        <el-card-title :title="title1" class="card2" />
        <div :class="multilingual.contactsTip[localLang]">
          {{ $t("page.applyUsername.contentTitles.contactsWay") }}
        </div>
        <!--  固定电话、手机和E-mail为重要联系方式，请务必认真填写  -->
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.contacts')"
          label-width="350px"
          prop="linkMan"
        >
          <!--  联系人  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.contactsMsg')"
            v-model="linkmanForm.linkMan"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.contactsTel')"
          label-width="350px"
          prop="telePhone"
        >
          <!--  联系人固定电话  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.contactsTelMsg')"
            v-model="linkmanForm.telePhone"
            maxlength="25"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('page.applyUsername.contentLabel.contactsFax')"
          label-width="350px"
        >
          <!--  联系人传真  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.contactsFaxMsg')"
            v-model="linkmanForm.facSimile"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <!-- === -->

        <!-- <el-form-item v-if="!isLogin" :label="$t('page.supInfo.contentLabel.Authentication')" label-width="350px"
          prop="authentication">
          <el-radio-group v-model="Authentication" @change="changeAuthentication">
            <el-radio :label="1" value="1">{{
              $t("page.supInfo.inputPlc.mobilePhone")
            }}</el-radio>
            <el-radio :label="0" value="0">{{
              $t("page.supInfo.inputPlc.email")
            }}</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item v-if="isChinese === 'zh-cn'" :label="$t('page.applyUsername.contentLabel.contactsMobile')"
          label-width="350px" :prop="isChinese === 'zh-cn' ? 'userMobile' : ''">
        
          <el-input :placeholder="$t('page.applyUsername.inputPlc.contactsMobileMsg')" v-model="linkmanForm.userMobile"
            show-word-limit :maxlength="multilingual.userMobile[localLang]"></el-input>
        </el-form-item> -->
        <!--  && userForm.Authentication == 1 -->
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.contactsMobile')"
          label-width="350px"
          prop="userMobile"
        >
          <!--  联系人手机 (英文) -->
          <el-input
            @input="() => isEnabled++"
            :placeholder="$t('page.applyUsername.inputPlc.contactsMobileMsg')"
            v-model="linkmanForm.userMobile"
            show-word-limit
            :maxlength="15"
          ></el-input>
        </el-form-item>
        <!--  && userForm.Authentication == 1 -->
        <!-- <el-form-item label-width="356px" v-if="!isLogin" class="formSlide">
          <machineCheck key="sms-slider" @ncData="ncData" id="sms-slider" :isEnabled="isEnabled"></machineCheck>
        </el-form-item> -->
        <!--  验证码  -->
        <!-- && userForm.Authentication == 1 -->
        <!-- <el-form-item :label="$t('page.applyUsername.contentLabel.authCode')" label-width="350px" prop="authCode"
          class="authCode" v-if="!isLogin ">
         
          <el-input  :placeholder="$t('page.applyUsername.inputPlc.authCodeMsg')" v-model="linkmanForm.authCode"
            autocomplete="noneoff"></el-input>
          <el-button type="primary" :disabled="codeDisabled" @click="getCode" class="codeBtn" v-show="show"
            :class="{ enBtn: !languagezh_cn }">{{ $t("page.applyUsername.btn.getCode") }}</el-button>
          <el-button type="primary" @click="getCode" class="count" v-show="!show" :disabled="timeDisabled">{{ count
            }}</el-button>
        </el-form-item> -->

        <el-form-item
          v-if="userForm.Authentication == 0"
          :label="$t('page.applyUsername.contentLabel.contactsEmail')"
          label-width="350px"
          prop="email"
        >
          <!--  联系人E-mail  -->
          <el-input
            @input="() => isEnabled++"
            :placeholder="$t('page.applyUsername.inputPlc.contactsEmailMsg')"
            v-model="linkmanForm.email"
            maxlength="320"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label-width="356px"
          v-if="!isLogin && userForm.Authentication == 0"
          class="formSlide"
        >
          <machineCheck
            key="sms-slider"
            @ncData="ncData"
            id="sms-slider"
            :isEnabled="isEnabled"
          ></machineCheck>
        </el-form-item> -->
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.authCode')"
          label-width="350px"
          prop="authCode"
          class="authCode"
          v-if="!isLogin && userForm.Authentication == 0"
        >
          <!--  验证码  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.authCodeMsg')"
            v-model="linkmanForm.authCode"
            autocomplete="noneoff"
          ></el-input>
          <el-button
            type="primary"
            :disabled="codeDisabled"
            @click="getEmailCode"
            class="codeBtn"
            v-show="show"
            :class="{ enBtn: !languagezh_cn }"
            >{{ $t("page.applyUsername.btn.getCode") }}</el-button
          >
          <el-button
            type="primary"
            @click="getCode"
            class="count"
            v-show="!show"
            :disabled="timeDisabled"
            >{{ count }}</el-button
          >
        </el-form-item>
        <!-- === -->
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.ID')"
          label-width="350px"
          prop="contactIdcard"
          v-if="languagezh_cn"
        >
          <!--  联系人身份证号/境外社保号  -->
          <el-input
            class="IDplac"
            :placeholder="$t('page.applyUsername.inputPlc.IDMsg')"
            v-model="linkmanForm.contactIdcard"
            show-word-limit
            maxlength="18"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="back()"
      >
        <span>{{ $t("basicLayout.btn")[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="next()"
      >
        <span>{{ $t("basicLayout.btn")[1] }}</span>
      </el-button>
    </div>
    <!-- 下一步弹层 -->
    <el-dialog
      :title="$t('page.applyUsername.dialogMsg.title')"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <span
        >{{ $t("page.applyUsername.dialogMsg.msg1") }}“{{
          linkmanForm.reCompany + "（" + linkmanForm.orgFullName + "）"
        }}”{{ $t("page.applyUsername.dialogMsg.msg2") }}</span
      >
      <!-- 您现在选择的推荐单位是“”，推荐单位负责审核您公司的注册信息。请仔细核对，避免出错！-->
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >{{ $t("page.productInfo.btn.cancel") }}</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="confirmNext">{{
          $t("page.productInfo.btn.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    <choosePartyA
      ref="choosePartyA"
      :selectedTitle="languagezh_cn ? '已选择单位' : 'Selected unit'"
      :title="languagezh_cn ? '请选择单位' : 'Please select a unit'"
      mode="radio"
      :isselectedData="partyASelectedNode"
      :requestTreeFunction="queryRecommendedUnitTree"
      :requestSeachFunction="queryMemberGroup"
      @selectedStaffSuccess="selectPartyA"
    />
    <!-- 推荐单位 弹框 -->
    <el-dialog
      v-if="isRecommendedUnitTreeShow"
      :visible.sync="dialogRecommendedUnitTree"
      title="选择推荐单位"
      width="600px"
      append-to-body
      :before-close="beforeClose"
    >
      <div class="left-trrr" style="min-height: 500px">
        <div class="tree-box">
          <el-tree
            ref="tree"
            :props="defaultProps"
            :load="recommendedUnitLoadNode"
            node-key="companyId"
            lazy
            :check-strictly="true"
            show-checkbox
            @check="getCheckedNodes"
            @check-change="getCurrentNode"
          >
          </el-tree>
        </div>
      </div>
      <div size="mini" type="default-mini" slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="closeDialog"
          >取消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="confirmForm"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
// import recommendUnits from "./recommendUnits";
import { addUrlPerFix } from "@/basa/utils";
import {
  AddressRegionList,
  AddressByCodeRegionList,
  createSupplierAccount,
  qrySupRegistAccountInfo,
  //checkRecommendOrg,
  saveSupplierRegistInfo,
  checkSuppilerInfo,
  sendVerificationCode,
  checkSendEmailCode,
  checkContactByMobile,
  qryTycSearch,
  qrySupTycInfo,
  checkMobileVerificationCode,
  checkEmailVerificationCode,
  queryMemberGroup,
  queryRecommendedUnitTree,
  qrySupWhiteListBySupName,
} from "../../../api/supRegister.js";
import Setting from "@/setting/setting";
import Cookies from "js-cookie";
const savedLocaleKey = Setting.i18n.cookieLable;
import { mapActions } from "vuex";
// import zhCN from "../../../../i18n/locale/zh-CN";
// import layoutLocale from "../../../../i18n/locale/layoutLocaleI18n";
// import enUS from "../../../../i18n/locale/en-US";
// import esEs from "../../../../i18n/locale/es-ES";
// import faFR from "../../../../i18n/locale/fa-FR";
// import elsRU from "../../../../i18n/locale/els-RU";
// import albAR from "../../../../i18n/locale/alb-AR";
import choosePartyA from "../../../components/staffSelector";
import machineCheck from "../../../components/no-captcha";

export default {
  name: "applyUsername",
  components: {
    machineCheck,
    choosePartyA,
  },
  data() {
    // 查询推荐单位
    // const checkUnit = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error(window.$t('page.applyUsername.inputRules.reCompanyMsg')));  //推荐单位不能为空
    //   }else {
    // checkRecommendOrg({
    //   isOverseas: '0',
    //   recommendCompanyName: value
    // }).then((res)=>{
    //   if(res.data.code === '0') {
    //     if(res.data.data.existsFlag === '1' && res.data.data.topFlag === '0'){
    //       this.linkmanForm.recommendIndyId = res.data.data.recommendOrgInfoBO.companyId
    //       this.linkmanForm.recommendIndyCode = res.data.data.autoCode
    //       callback()
    //     }else{
    //       if(res.data.data.existsFlag === '0') {
    //         callback(new Error(window.$t('page.applyUsername.inputRules.reCompanyMsg1')));  // 推荐单位不存在
    //       } else if (res.data.data.topFlag === '1') {
    //         callback(new Error(window.$t('page.applyUsername.inputRules.reCompanyMsg2'))); // 请输入非集团总部单位
    //       }
    //     }
    //   } else {
    //     callback(new Error(window.$t('page.applyUsername.inputRules.reCompanyMsg'))); // 推荐单位不存在
    //   }
    // })
    // }
    // };
    return {
      readonly: false,
      tycInfo: JSON.stringify({}),
      isShow1: false,
      isWhite: false,
      isHaiwaiorGAT: false,
      partyASelectedNode: [],
      clickUrl: `${addUrlPerFix("sp.iccec.cn")}/retrievePassword`,
      title: window.$t("page.applyUsername.contentTitle.loginInfo"), // 登陆账号和密码
      title1: window.$t("page.applyUsername.contentTitle.contacts"), // 联系人和联系方式
      title2: window.$t("page.applyUsername.contentTitle.reCompany"), // 推荐单位
      multilingual: Object.freeze({
        userMobile: {
          undefined: 11,
          "zh-cn": 11,
          "en-gb": "25",
          "es-es": "", // 西班牙语
          "fr-fr": "",
          "ru-ru": "",
          ar: "",
        },
        reCompanyTitleClass: {
          undefined: "reCompanyTitle",
          "zh-cn": "reCompanyTitle",
          "en-gb": "reCompanyTitle_en",
          "es-es": "reCompanyTitle_en", // 西班牙语
          "fr-fr": "reCompanyTitle_en",
          "ru-ru": "reCompanyTitle_en",
          ar: "reCompanyTitle_en",
        },
        contactsTip: {
          undefined: "grouptips",
          "zh-cn": "grouptips",
          "en-gb": "grouptips_en",
          "es-es": "grouptips_en", // 西班牙语
          "fr-fr": "grouptips_en",
          "ru-ru": "grouptips_en",
          ar: "grouptips_en",
        },
        areaShow: {
          undefined: true,
          "zh-cn": true,
          "en-gb": false,
          "es-es": false, // 西班牙语
          "fr-fr": false,
          "ru-ru": false,
          ar: false,
        },
      }),
      localLang: Cookies.get(savedLocaleKey) || "zh-cn",
      isLogin: false,
      labelPosition: "right",
      isShow: false,
      isThreeShow: false,
      isDisabled: false,
      value11: 0,
      disabledLoginId: false,
      existFlag: "",
      codeDisabled: false,
      sliderDisabled: false,
      show: true,
      count: "",
      timer: null,
      timeDisabled: true,
      slideShow: true,
      threeZ: "", // 是否展示三证合一
      isGAT: false, //是否港澳台
      // 表单数据
      Authentication: 0,
      userForm: {
        Authentication: 0,
        supplierName: "",
        loginId: "",
        authCode: "",
        userName: "",
        password: "",
        rePassword: "",
        isThree: "",
        creditCode: "",
        business: "",
        organizingInstitution: "",
        date3: "",
        date4: "",
        dutyParagraph: "",
        userMobile: "",
        isOverseas: 0,
        contactMobile: "",
        props: {
          checkStrictly: true,
          expandTrigger: "hover", // 鼠标滑过展开
          lazy: true,
          lazyLoad(node, resolve) {
            console.log(node, "lazyLoad");
            if (node.level === 0) {
              AddressRegionList({ parentCode: "" }).then((response) => {
                let cities = response.data.data.map((value, i) => ({
                  value: value.addressCode,
                  label: value.addressName,
                  leaf: false,
                }));
                cities.forEach((res) => {
                  res.disabled = true;
                });
                resolve(cities);
              });
            } else if (
              node.label == "港澳台" &&
              node.level >= 1 &&
              node.level < 3
            ) {
              AddressByCodeRegionList({ addressCode: node.data.value }).then(
                (response) => {
                  let areas = response.data.data.map((value, i) => ({
                    value: value.addressCode,
                    label: value.addressName,
                    leaf: !(value.lastFlag === 0) || node.level === 3,
                  }));
                  if (node.level == 1) {
                    areas.forEach((res) => {
                      res.disabled = true;
                    });
                  } else if (node.level == 2) {
                    //广东东莞、中山、海南儋州只用选到第三级
                    res.data.data.forEach((res) => {
                      if (
                        res.parentCode != 110 &&
                        res.parentCode != 121 &&
                        res.parentCode != 143 &&
                        res.addressCode != 441900 &&
                        res.addressCode != 442000 &&
                        res.addressCode != 460400
                      ) {
                        res.disabled = true;
                      }
                    });
                  }
                  areas.map((item) => {
                    if (node.label == "港澳台") {
                      item.leaf = item.lastFlag === 0;
                    } else {
                      item.leaf = item.lastFlag === 1;
                    }
                  });
                  resolve(areas);
                }
              );
            } else if (node.level >= 1 && node.level < 4) {
              AddressByCodeRegionList({ addressCode: node.data.value }).then(
                (response) => {
                  let areas = response.data.data.map((value, i) => ({
                    value: value.addressCode,
                    label: value.addressName,
                    parentCode: value.parentCode,
                    leaf: !(value.lastFlag === 0) || node.level === 3,
                  }));
                  if (node.level == 1) {
                    areas.forEach((res) => {
                      res.disabled = true;
                    });
                  } else if (node.level == 2) {
                    //广东东莞、中山、海南儋州只用选到第三级
                    areas.forEach((obj) => {
                      if (
                        obj.parentCode != 110 &&
                        obj.parentCode != 121 &&
                        obj.parentCode != 143 &&
                        obj.label != "东莞市" &&
                        obj.label != "中山市" &&
                        obj.label != "儋州市"
                      ) {
                        obj.disabled = true;
                      }
                    });
                  }
                  resolve(areas);
                }
              );
            }
          },
        },
        value1: [],
        options: [],
        factCapl: "",
      },
      linkmanForm: {
        linkMan: "",
        authode: "",
        authCode: "",
        telePhone: "",
        facSimile: "",
        mobile: "",
        userMobile: "",
        email: "",
        contactIdcard: "",
        reCompany: "",
        recommendIndyId: "",
        recommendIndyCode: "",
        provinces: "",
        value: [],
      },
      // 表单验证规则
      userFormRules: {},
      linkmanFormRules: {
        linkMan: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsMsg"),
            trigger: "blur",
          },
          // {validator:validators.userName,message:window.$t('page.applyUsername.inputRules.contactsMsg')},
        ],
        telePhone: [
          {
            required: false,
            message: window.$t("page.applyUsername.inputPlc.contactsTelMsg"),
            trigger: "blur",
          },
          {
            pattern: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,
            message: window.$t("page.applyUsername.inputRules.contactsTelMsg"),
            trigger: "blur",
          },
        ],
        facSimile: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsFaxMsg"),
            trigger: "blur",
          },
          {
            pattern: /^(\d{3,4}-)?\d{7,8}$/,
            message: window.$t("page.applyUsername.inputRules.contactsFaxMsg"),
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsMobileMsg"),
            trigger: "blur",
          },
        ],
        //   {pattern: /^1[34578]\d{9}$/, message: window.$t('page.applyUsername.inputRules.contactsMobileMsg')}],
        contactMobile: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsTelMsg"),
            trigger: "blur",
          },
          // { pattern: /\-/, message: window.$t('page.applyUsername.inputRules.contactsMobileMsg'), trigger: 'blur' },
        ],
        email: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsEmailMsg"),
            trigger: "blur",
          },
          {
            pattern: /\@/,
            message: window.$t(
              "page.applyUsername.inputRules.contactsEmailMsg"
            ),
            trigger: "blur",
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: window.$t(
              "page.applyUsername.inputRules.contactsEmailMsg"
            ),
            trigger: "blur",
          },
        ],
        reCompany: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputRules.reCompanyMsg"),
            trigger: ["blur", "change"],
          },
        ],
        // userMobile: [
        //   { required: true, message: window.$t('page.applyUsername.inputPlc.contactsTelMsg'), trigger: 'blur' },
        //   // { pattern: /\-/, message: window.$t('page.applyUsername.inputRules.contactsMobileMsg'), trigger: 'blur' },

        // ],
        authCode: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputRules.codemsg "),
            trigger: "blur",
          },
        ],
        contactIdcard: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.IDMsg"),
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
      supInfoApplyId: "",
      supNameList: [],
      timeout: null,
      isSkyEyes: false, // 是否天眼查
      tempSupinfoId: "",
      isEnabled: 0,
      isChinese: Cookies.get(savedLocaleKey) || "zh-cn",
      isRecommendedUnitTreeShow: false,
      dialogRecommendedUnitTree: false,
      defaultProps: {
        label: "companyName",
        //children: "child",
        isLeaf: "leaf",
      },
      // 是否勾选了节点
      checkedFlag: false,
      companyId: "",
    };
  },
  activated() {
    this.linkmanForm.authCode = "";
  },

  computed: {
    pickerOptions1() {
      let that = this;
      return {
        disabledDate: function (time) {
          if (that.userForm.date4) {
            return time.getTime() > new Date(that.userForm.date4).getTime();
          } else {
            return false;
          }
        },
      };
    },
    pickerOptions2() {
      let that = this;
      return {
        disabledDate: function (time) {
          if (that.userForm.date3) {
            return time.getTime() < new Date(that.userForm.date3).getTime();
          } else {
            return false;
          }
        },
      };
    },
  },
  watch: {
    "linkmanForm.contactIdcard"(newValue, oldValue) {
      this.linkmanForm.contactIdcard = newValue.replace(/[\W]/g, "");
    },
  },
  created() {
    if (this.$route.query.isChangeInfo) {
      this.isDisabled = true;
    }
    if (this.$route.query.page) {
      this.changeCheckPage(3);
    }
    if (
      Cookies.get(savedLocaleKey) === undefined ||
      Cookies.get(savedLocaleKey) === "zh-cn"
    ) {
      this.threeZ = true;
      this.userForm.isThree = 1;
      this.isShow = true;
    } else {
      this.threeZ = false;
      this.isShow = false;
      this.isThreeShow = false;
      this.linkmanFormRules.telePhone = [];
      this.linkmanFormRules.facSimile = [];
    }
    if (this.$route.query.tempSupinfoId) {
      this.isLogin = true;
      this.userFormRules = {
        supplierName: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.supNameMSg"),
            trigger: "blur",
          },
        ],
        isThree: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.choose"),
            trigger: "change",
          },
        ],
        value1: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.provincesMsg"),
            trigger: "change",
          },
        ],
        creditCode: [
          {
            required: window.languagezh_cn ? false : true,
            message: window.$t("page.supInfo.inputPlc.unifyCode"),
            trigger: "blur",
          },
          {
            pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
        ],
        creditCode2: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.unifyCode"),
            trigger: "blur",
          },
          {
            pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
        ],
        GATcreditCode: [
          {
            required: true,
            message: "请输入港澳台统一代码证",
            trigger: "blur",
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: "请输入正确的港澳台统一代码证",
            trigger: "blur",
          },
        ],

        business: [
          { required: true, message: "请输入营业执照号", trigger: "blur" },
          {
            pattern: /[1-9]\d/,
            message: "请输入正确的营业执照号",
            trigger: "blur",
          },
          { min: 15, message: "不能小于15位", trigger: "blur" },
        ],
        organizingInstitution: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.framework"),
            trigger: "blur",
          },
        ],
        date3: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.chooseDate"),
            trigger: "change",
          },
        ],
        date4: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.chooseDate"),
            trigger: "change",
          },
        ],
        dutyParagraph: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.dutyParagraph"),
            trigger: "blur",
          },
        ],
        userName: [
          {
            required: true,
            message: window.languagezh_cn
              ? "请输入登录账号"
              : "Please enter your username",
            trigger: "blur",
          },
          {
            pattern: /(^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]$)/,
            message: window.languagezh_cn
              ? "请输入登录账号，支持字母或字母数字组合"
              : "Only enter letters or alphanumeric combinations!",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.pwdMsg"),
            trigger: "blur",
          },
        ],
        rePassword: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.repwdMsg"),
            trigger: "blur",
          },
        ],
        loginId: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
        ],
      };
      this.getSupRegistAccountInfo();
    } else {
      this.userFormRules = {
        supplierName: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.supNameMSg"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    window.$t("page.applyUsername.inputRules.supNameMSg")
                  )
                ); // 供应商名称不能为空
              } else {
                setTimeout(() => {
                  this.isShow1 = false;
                  checkSuppilerInfo({
                    supName: this.userForm.supplierName,
                  }).then((res) => {
                    console.log(res);
                    if (res.data.data.returnCheckCode === "NO_SP0001") {
                      this.isShow1 = true;
                      this.qrySupWhiteListBySupName(this.userForm.supplierName);
                      // callback(new Error(window.$t('page.applyUsername.inputRules.supNameMSg1'))) // 该供应商名称已存在
                    } else if (res.data.data.returnCheckCode === "RP_SP0001") {
                      this.isShow1 = true;
                      this.qrySupWhiteListBySupName(this.userForm.supplierName);
                      // callback(new Error(window.$t('page.applyUsername.inputRules.supNameMSg1'))) // 该供应商名称已存在
                    } else {
                      this.isShow1 = false;
                      callback();
                      this.qrySupWhiteListBySupName(this.userForm.supplierName);
                    }
                  });
                }, 100);
              }
            },
            trigger: "blur",
          },
        ],
        isThree: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.choose"),
            trigger: "change",
          },
        ],
        value1: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.provincesMsg"),
            trigger: "change",
          },
        ],
        creditCode: [
          {
            required: window.languagezh_cn ? false : true,
            message: window.$t("page.supInfo.inputPlc.unifyCode"),
            trigger: "blur",
          },
          {
            pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("统一社会信用代码不能为空"));
              } else {
                checkSuppilerInfo({
                  regNum: value,
                }).then((res) => {
                  console.log(res);
                  if (res.data.data === "RP_SP0033") {
                    callback(new Error("该统一社会信用代码已存在"));
                  } else {
                    callback();
                  }
                });
              }
            },
            trigger: "blur",
          },
        ],
        creditCode2: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.unifyCode"),
            trigger: "blur",
          },
          {
            pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur",
          },
        ],
        GATcreditCode: [
          {
            required: true,
            message: "请输入港澳台统一代码证",
            trigger: "blur",
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: "请输入正确的港澳台统一代码证",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("港澳台统一代码证不能为空"));
              } else {
                checkSuppilerInfo({
                  regNum: value,
                }).then((res) => {
                  console.log(res);
                  if (res.data.data === "RP_SP0033") {
                    callback(new Error("该港澳台统一代码证已存在"));
                  } else {
                    callback();
                  }
                });
              }
            },
            trigger: "blur",
          },
        ],
        business: [
          { required: true, message: "请输入营业执照号", trigger: "blur" },
          {
            pattern: /[0-9]\d/,
            message: "请输入正确的营业执照号",
            trigger: "blur",
          },
          { min: 15, message: "不能小于15位", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("营业执照号不能为空"));
              } else {
                checkSuppilerInfo({
                  regNum: value,
                }).then((res) => {
                  console.log(res);
                  if (res.data.data === "RP_SP0033") {
                    callback(new Error("该营业执照号已存在"));
                  } else {
                    callback();
                  }
                });
              }
            },
            trigger: "blur",
          },
        ],
        organizingInstitution: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.framework"),
            trigger: "blur",
          },
        ],
        date3: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.chooseDate"),
            trigger: "change",
          },
        ],
        date4: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.chooseDate"),
            trigger: "change",
          },
        ],
        dutyParagraph: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.dutyParagraph"),
            trigger: "blur",
          },
        ],
        // loginId: [{ required: true, message: window.$t('page.applyUsername.inputPlc.idMsg'), trigger: 'blur' },
        //   {min:2,max:8,message:window.$t('page.applyUsername.inputRules.idMsg1')},
        //   { pattern:/^[A-Za-z0-9_]{2,8}$/, message: window.$t('page.applyUsername.inputRules.idMsg2')}],
        // userMobile: [{ required: true, message: window.$t('page.applyUsername.inputPlc.contactsMobileMsg'), trigger: 'blur' },
        // { pattern: Cookies.get(savedLocaleKey) === 'zh-cn' === undefined || Cookies.get(savedLocaleKey) === 'zh-cn' ? /^1[3456789]\d{9}$/ : '', message: window.$t('page.applyUsername.inputRules.contactsMobileMsg'), trigger: 'blur' },
        // {
        //   validator: (rule, value, callback) => {
        //     if (!value) {
        //       callback(new Error(window.$t('page.applyUsername.inputRules.mobilemsg'))); // 手机号不能为空
        //     }
        //     //  else {
        //     //   checkSuppilerInfo({
        //     //     registMobile: value
        //     //   }).then((res) => {
        //     //     console.log(res)
        //     //     if (res.data.data === 'RP_SP0002') {
        //     //       callback(new Error(window.$t('page.applyUsername.inputRules.mobilemsg1'))) // 该手机号已存在
        //     //     } else {
        //     //       callback()
        //     //     }
        //     //   })
        //     // }
        //   }, trigger: 'blur'
        // }
        // ],
        userName: [
          {
            required: true,
            message: window.languagezh_cn
              ? "请输入登录账号"
              : "Please enter your username",
            trigger: "blur",
          },
          {
            pattern: /(^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]$)/,
            message: window.languagezh_cn
              ? "请输入登录账号，支持字母或字母数字组合"
              : "Only enter letters or alphanumeric combinations!",
            trigger: "blur",
          },
        ],
        authCode: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.authCodeMsg"),
            trigger: "blur",
          },
          // {validator:(rule, value, callback) => {
          //     if (!value) {
          //       callback(new Error('验证码不能为空'));
          //     }else {
          //       checkContactByMobile({
          //         mobile: this.userForm.userMobile,
          //         inputAuthCode: value
          //       }).then((res)=>{
          //         console.log(res)
          //         if(res.data.code === '200') {
          //           callback(new Error('验证码错误'))
          //         } else {
          //           callback()
          //         }
          //       })
          //     }
          //   },trigger: 'blur'}
        ],
        password: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.pwdMsg"),
            trigger: "blur",
          },
          {
            min: 8,
            max: 16,
            message: window.$t("page.applyUsername.inputRules.pwdMsg1"),
          },
          {
            pattern:
              /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}/,
            message: window.$t("page.applyUsername.inputRules.pwdMsg2"),
            trigger: "blur",
          },
        ],

        rePassword: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.repwdMsg"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入密码"));
              } else if (value !== this.userForm.password) {
                callback(
                  new Error(window.$t("page.applyUsername.inputRules.repwdMsg"))
                );
              } else {
                callback();
              }
            },
            message: window.$t("page.applyUsername.inputRules.repwdMsg"),
            trigger: "blur",
          },
        ],
      };
    }
  },
  mounted() {},
  methods: {
    ...mapActions(["changeCheckPage"]),
    queryMemberGroup,
    queryRecommendedUnitTree,
    back() {
      this.changeCheckPage(2);
      this.$router.push({
        path: "/maPerfectInfo/moralAgreement",
        query: {
          tempSupinfoId: this.$route.query.tempSupinfoId
            ? this.$route.query.tempSupinfoId
            : this.tempSupinfoId,
          tempOrFormalFlag: this.$route.query.tempOrFormalFlag,
        },
      });
    },
    next() {
      if (
        Cookies.get(savedLocaleKey) === undefined ||
        Cookies.get(savedLocaleKey) === "zh-cn"
      ) {
        if (this.userForm.isThree === 0) {
          this.isShow = false;
          this.isThreeShow = true;
        } else if (this.userForm.isThree === 1) {
          this.isThreeShow = false;
          this.isShow = true;
        }
      } else {
        this.isShow = false;
        this.isThreeShow = false;
      }
      const rule1 = new Promise((resolve, reject) => {
        this.$refs.userFormRef1.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            setTimeout(() => {
              const isError = document.getElementsByClassName("is-error");
              isError[0].querySelector("input").focus();
            }, 100);
            return false;
          }
        });
      });
      const rule3 = new Promise((resolve, reject) => {
        this.$refs.userFormRef3.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            setTimeout(() => {
              const isError = document.getElementsByClassName("is-error");
              isError[0].querySelector("input").focus();
            }, 100);
            return false;
          }
        });
      });

      const rule2 = new Promise((resolve, reject) => {
        this.$refs.userFormRef2.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            setTimeout(() => {
              const isError = document.getElementsByClassName("is-error");
              isError[0].querySelector("input").focus();
            }, 100);
            return false;
          }
        });
      });
      Promise.all([rule1, rule2, rule3]).then(async () => {
        // if(!Cookies.get('111')) {
        //   checkContactByMobile({
        //     mobile: this.userForm.userMobile,
        //     inputAuthCode: this.userForm.authCode
        //   }).then(res => {
        //     if(res.data.code === '0') {
        //       this.dialogVisible = true
        //     } else {
        //       this.$message.error('验证码错误')
        //     }
        //   })
        // } else {
        //   this.dialogVisible = true
        // }
        let codeAuth = false;
        if (!this.isLogin && !this.linkmanForm.authCode) {
          this.$message({
            showClose: true,
            type: "error",
            message: window.languagezh_cn
              ? "请输入验证码"
              : "Please enter the verification code",
            ccuiCustom: true,
          });
          return;
        }

        if (this.Authentication == 1 && !this.isLogin) {
          await checkMobileVerificationCode({
            phoneNumber: this.linkmanForm.userMobile,
            verificationCode: this.linkmanForm.authCode,
            isShowLoading: true,
          }).then((res) => {
            codeAuth = true;
          });
        } else if (!this.isLogin) {
          await checkEmailVerificationCode({
            email: this.linkmanForm.email,
            verificationCode: this.linkmanForm.authCode,
            isShowLoading: true,
          }).then((res) => {
            codeAuth = true;
          });
        }
        this.dialogVisible = true;
      });
    },
    selectPartyA([data]) {
      this.companyId = data.companyId;
      this.linkmanForm.recommendIndyId = data.companyId;
      this.linkmanForm.recommendIndyCode = data.autoCode;
      this.linkmanForm.reCompany = window.languagezh_cn
        ? data.companyName
        : data.companyEnName;
      this.linkmanForm.orgFullName = data.orgFullName;
    },
    changeShow() {
      if (!this.userForm.supplierName) {
        this.isShow1 = false;
      }
    },
    removehtmlTags(text) {
      return text.replace(/<[^>]+>/g, "");
    },
    changeAuthentication(val) {
      this.linkmanForm.userMobile = "";
      this.linkmanForm.email = "";
      this.linkmanForm.authCode = "";
      this.$nextTick(() => {
        this.$refs["userFormRef2"].clearValidate(["authCode"]);

        if (val == 0) {
          this.$refs["userFormRef2"].clearValidate(["userMobile"]);
        } else {
          this.$refs["userFormRef2"].clearValidate(["email"]);
        }
      });
      this.isEnabled++;
      this.codeDisabled = true;
      this.userForm.Authentication = val;
    },
    changeRadio(val) {
      if (val === 0) {
        this.isShow = false;
        this.isThreeShow = true;
        this.$refs.isShowRef.clearValidate();
      } else if (val === 1) {
        this.isThreeShow = false;
        this.isShow = true;
        this.$refs.isThreeShowRef1 &&
          this.$refs.isThreeShowRef1.clearValidate();
        this.$refs.isThreeShowRef2 &&
          this.$refs.isThreeShowRef2.clearValidate();
        this.$refs.isThreeShowRef3 &&
          this.$refs.isThreeShowRef3.clearValidate();
        this.$refs.isThreeShowRef4 &&
          this.$refs.isThreeShowRef4.clearValidate();
        this.$refs.isThreeShowRef5 &&
          this.$refs.isThreeShowRef5.clearValidate();
      }
    },
    // 省市地区列表
    handleChange(val) {
      if (val.length > 2) {
        if (
          val[2] == "441900" ||
          val[2] == "442000" ||
          val[2] == "44200" ||
          val.length == 4
        ) {
          this.$refs.myCascader.dropDownVisible = false;
        }
        if (val[0] == "970000") {
          //港澳台
          this.$refs.myCascader.dropDownVisible = false;
          this.isGAT = true;
          this.isThree = 1;
          this.changeRadio(1);
        } else {
          this.isGAT = false;
        }
        if (val[0] == "980000" || val[0] == "970000") {
          this.isHaiwaiorGAT = true;
        } else {
          this.isHaiwaiorGAT = false;
        }
      }
      setTimeout(() => {
        this.$nextTick(() => {
          this.getLabelValue();
        });
      }, 1);
    },
    qrySupWhiteListBySupName(supName) {
      qrySupWhiteListBySupName({
        supName: supName,
      }).then((obj) => {
        if (obj.data.data.rows.length > 0) {
          this.isWhite = true;
        } else {
          this.isWhite = false;
        }
      });
    },
    getLabelValue() {
      this.userForm.locationCode = "";
      this.userForm.provinceCode = "";
      this.userForm.cityCode = "";
      this.userForm.countyCode = "";
      const obj = this.$refs["myCascader"].getCheckedNodes();
      console.log(obj);
      // this.linkmanForm.country = obj[0].pathLabels[0];
      this.userForm.locationCode = obj[0].path[0];
      this.userForm.provinceCode = obj[0].path[1];
      this.userForm.cityCode = obj[0].path[2];
      // this.userForm.countyCode = JSON.stringify(obj[0].path);
      this.userForm.countyCode = obj[0].path[3];
      this.userForm.locationName = obj[0].pathLabels[0];
      this.userForm.provinceName = obj[0].pathLabels[1];
      this.userForm.cityName = obj[0].pathLabels[2];
      this.userForm.countyName = obj[0].pathLabels[3];
      console.log(this.userForm.locationCode);
      console.log(this.userForm.provinceCode);
      console.log(this.userForm.cityCode);
      console.log(this.userForm.countyCode);
    },
    // 确定下一步
    async confirmNext() {
      sessionStorage.setItem("countyCode", this.userForm.countyCode);
      sessionStorage.setItem("countyName", this.userForm.countyName);
      this.dialogVisible = false;
      if (this.existFlag) {
        saveSupplierRegistInfo({
          dataSourceFlag: 0,
          isOverseas:
            Cookies.get(savedLocaleKey) === undefined ||
            Cookies.get(savedLocaleKey) === "zh-cn"
              ? 0
              : 1,
          saveOrCommitFlag: "2",
          supRegistTab: "4",
          tycInfo: this.tycInfo,
          tempSupinfoId: this.supInfoApplyId,
          supRegistAccountInfoBO: {
            dataSourceFlag: 0,
            isCredentials: this.isGAT ? 1 : this.userForm.isThree,
            supName: this.userForm.supplierName,
            recommendIndyId: this.linkmanForm.recommendIndyId,
            recommendIndyCode: this.linkmanForm.recommendIndyCode,
            recommendIndyName: this.linkmanForm.reCompany,
            regNum:
              this.userForm.isThree === 1
                ? this.userForm.creditCode
                : this.userForm.business,
            orgCode:
              this.userForm.isThree === 1
                ? ""
                : this.userForm.organizingInstitution,
            orgCredentialsStart:
              this.userForm.isThree === 1 ? "" : this.userForm.date3,
            orgCredentialsEnd:
              this.userForm.isThree === 1 ? "" : this.userForm.date4,
            taxCode:
              this.userForm.isThree === 1 ? "" : this.userForm.dutyParagraph,
            locationCode: this.userForm.locationCode,
            provinceCode: this.userForm.provinceCode,
            cityCode: this.userForm.cityCode,
            countyCode: this.userForm.countyCode,
            locationName: this.userForm.locationName,
            provinceName: this.userForm.provinceName,
            cityName: this.userForm.cityName,
            countyName: this.userForm.countyName,
            registAccountContactInfoBO: {
              contactName: this.linkmanForm.linkMan,
              contactMobile: this.linkmanForm.userMobile,
              contactTel: this.linkmanForm.telePhone,
              contactFax: this.linkmanForm.facSimile,
              contactEmail: this.linkmanForm.email,
              contactIdcard: this.linkmanForm.contactIdcard,
            },
          },
          isShowLoading: true,
        }).then((res) => {
          this.changeCheckPage(4);
          this.$router.push({
            path: "/maPerfectInfo/basicInformation",
            query: {
              tempSupinfoId: this.$route.query.tempSupinfoId
                ? this.$route.query.tempSupinfoId
                : this.tempSupinfoId,
              tempOrFormalFlag: this.$route.query.tempOrFormalFlag,
            },
          });
        });
        return false;
      }

      createSupplierAccount({
        dataSourceFlag: 0,
        isOverseas:
          Cookies.get(savedLocaleKey) === undefined ||
          Cookies.get(savedLocaleKey) === "zh-cn"
            ? 0
            : 1,
        supName: this.userForm.supplierName,
        // userName: this.userForm.userMobile,
        isShowLoading: true,
        registMobile: this.userForm.userMobile,
        userPwd: this.userForm.password,
        userName: this.userForm.userName,
        isCredentials: this.isGAT
          ? 1
          : Cookies.get(savedLocaleKey) === undefined ||
            Cookies.get(savedLocaleKey) === "zh-cn"
          ? this.userForm.isThree
          : 0,
        regNum:
          this.userForm.isThree === 1
            ? this.userForm.creditCode
            : this.userForm.business,
        orgCode:
          this.userForm.isThree === 1
            ? ""
            : this.userForm.organizingInstitution,
        orgCredentialsStart:
          this.userForm.isThree === 1 ? "" : this.userForm.date3,
        orgCredentialsEnd:
          this.userForm.isThree === 1 ? "" : this.userForm.date4,
        taxCode: this.userForm.isThree === 1 ? "" : this.userForm.dutyParagraph,
        recommendIndyId: this.linkmanForm.recommendIndyId,
        recommendIndyCode: this.linkmanForm.recommendIndyCode,
        factCaplFlag: this.userForm.factCapl ? 0 : 1,
        tycInfo: this.tycInfo,
        factCapl: this.userForm.factCapl,
        recommendIndyName: this.linkmanForm.reCompany,
        locationCode: this.userForm.locationCode,
        provinceCode: this.userForm.provinceCode,
        cityCode: this.userForm.cityCode,
        countyCode: this.userForm.countyCode,
        locationName: this.userForm.locationName,
        provinceName: this.userForm.provinceName,
        cityName: this.userForm.cityName,
        countyName: this.userForm.countyName,
        operIpAddress: "10.88.201.31",
        registContactInfoBO: {
          contactName: this.linkmanForm.linkMan,
          contactMobile: this.linkmanForm.userMobile, //this.isChinese === 'zh-cn' ? this.linkmanForm.userMobile : this.userForm.contactMobile,
          contactTel: this.linkmanForm.telePhone,
          contactFax: this.linkmanForm.facSimile,
          contactEmail: this.linkmanForm.email,
          contactIdcard: this.linkmanForm.contactIdcard,
        },
      }).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            type: "success",
            duration: 3000,
            message:
              this.localLang == "zh-cn"
                ? "将生成账号信息，请注意留存账号、密码等重要信息（账号信息已同步发至联系人邮箱）！"
                : "An account will be generated, please note and keep the important account information (the account information has been synchronized to the contact's email address)!",
          });

          setTimeout(() => {
            this.changeCheckPage(4);
            this.tempSupinfoId = res.data.data.tempSupinfoId;
            this.$router.push({
              path: "/maPerfectInfo/basicInformation",
              query: { tempSupinfoId: this.tempSupinfoId },
            });
          }, 10);
        }
      });
    },
    // 获取注册申请用户信息
    async getSupRegistAccountInfo() {
      const { data } = await qrySupRegistAccountInfo({
        tempOrFormalFlag: this.$route.query.tempOrFormalFlag
          ? this.$route.query.tempOrFormalFlag
          : 0,
        supInfoApplyId: this.$route.query.tempSupinfoId,
        isShowLoading: true,
      });
      if (data.code === "0") {
        this.qrySupWhiteListBySupName(data.data.supRegistAccountInfoBO.supName);
        const res = data.data.supRegistAccountInfoBO;
        this.tycInfo = res.tycInfo;
        this.userForm.supplierName = res.supName;
        this.userForm.loginId = res.registMobile;
        this.userForm.userMobile = res.registMobile;
        this.linkmanForm.userMobile =
          res.registAccountContactInfoBO.contactMobile;
        this.userForm.password = res.userPwd;
        this.linkmanForm.orgFullName = data.data.orgFullName;
        console.log(res.userName, "res.userNameres.userName");

        this.userForm.userName = res.userName;
        this.userForm.rePassword = res.userPwd;
        this.userForm.isThree = res.isCredentials;
        if (res.isCredentials === 0) {
          this.userForm.business = res.regNum;
          this.userForm.organizingInstitution = res.orgCode;
          this.userForm.date3 = res.orgCredentialsStart;
          this.userForm.date4 = res.orgCredentialsEnd;
          this.userForm.dutyParagraph = res.taxCode;
          this.isShow = false;
          this.isThreeShow = true;
        } else if (res.isCredentials === 1) {
          this.userForm.creditCode = res.regNum;
          this.isThreeShow = false;
          this.isShow = true;
        }
        this.linkmanForm.linkMan = res.registAccountContactInfoBO.contactName;
        this.userForm.contactMobile =
          res.registAccountContactInfoBO.contactMobile;
        this.linkmanForm.telePhone = res.registAccountContactInfoBO.contactTel;
        this.linkmanForm.facSimile = res.registAccountContactInfoBO.contactFax;
        this.linkmanForm.mobile = res.registAccountContactInfoBO.contactMobile;
        this.linkmanForm.email = res.registAccountContactInfoBO.contactEmail;
        this.linkmanForm.contactIdcard =
          res.registAccountContactInfoBO.contactIdcard;
        this.linkmanForm.reCompany = res.recommendIndyName;
        this.userForm.locationName = res.locationName;
        this.userForm.locationCode = res.locationCode;
        this.userForm.provinceName = res.provinceName;
        this.userForm.provinceCode = res.provinceCode;
        this.userForm.cityName = res.cityName;
        this.userForm.cityCode = res.cityCode;
        this.userForm.countyName = res.countyName;
        this.userForm.countyCode = res.countyCode;
        this.existFlag = data.data.existFlag;
        this.supInfoApplyId = data.data.supInfoApplyId;
        this.userForm.value1 = [
          res.locationCode,
          res.provinceCode,
          res.cityCode,
          res.countyCode,
        ];
        if (this.$refs.myCascader && res.locationName) {
          this.$refs.myCascader.inputValue = res.locationName;
        }
        if (this.$refs.myCascader && res.provinceName) {
          this.$refs.myCascader.inputValue =
            this.$refs.myCascader.inputValue + "/" + res.provinceName;
        }
        if (this.$refs.myCascader && res.cityName) {
          this.$refs.myCascader.inputValue =
            this.$refs.myCascader.inputValue + "/" + res.cityName;
        }
        if (this.$refs.myCascader && res.countyName) {
          this.$refs.myCascader.inputValue =
            this.$refs.myCascader.inputValue + "/" + res.countyName;
        }
        console.log(
          this.$route.query.tempSupinfoId,
          "this.$route.query.tempSupinfoId"
        );

        if (this.$route.query.tempSupinfoId) {
          this.disabledLoginId = true;
          this.isDisabled = true;
        }
        if (res.locationCode == "970000") {
          this.isGAT = true;
        }
        if (res.locationCode == "980000" || res.locationCode == "970000") {
          this.isHaiwaiorGAT = true;
        } else {
          this.isHaiwaiorGAT = false;
        }
      }
    },
    // 滑块改变
    // sliderChange() {
    //   if(this.userForm.userMobile === '') {
    //     this.$message.error('请先输入手机号')
    //     this.value11 = 0
    //   } else {
    //     if(this.value11 === 0) {
    //       this.codeDisabled = true
    //     } else if (this.value11>0&&this.value11<100) {
    //       this.codeDisabled = true
    //       this.value11 = 0
    //     } else if (this.value11 === 100) {
    //       this.codeDisabled = false
    //       this.sliderDisabled = true
    //       this.slideShow = false
    //     }
    //   }
    // },
    // 获取验证码
    getCode() {
      // linkmanForm.reCompany
      sendVerificationCode({
        phoneNumbers: this.linkmanForm.userMobile, //this.isChinese === 'zh-cn' ? this.linkmanForm.userMobile : this.userForm.contactMobile
      }).then((res) => {
        console.log(res);
        if (res.data.code === "0") {
          this.$message.success(
            "The SMS verification code has been sent successfully, please pay attention to receiving it"
          );
        }
      });
      const TIME_COUNT = 180;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    getEmailCode() {
      this.$refs.userFormRef2.validateField("reCompany", (valid) => {
        console.log("校验结果 valid:", valid);
        if (valid == "The recommended unit cannot be empty") return;
        
        checkSendEmailCode({
          email: this.linkmanForm.email,
          cooperativeUnit: this.linkmanForm.recommendIndyId,

        }).then((res) => {
          console.log(res);
          if (res.data.code === "0") {
            this.$message.success(
              "Email verification code sent successfully, please note receiving"
            );
          }
        });
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },
    // 天眼查
    querySearchAsync(queryString, callback) {
      if (queryString) {
        qryTycSearch({
          companyName: queryString,
        }).then((res) => {
          res.data.data.forEach((obj) => {
            // obj.name=this.removehtmlTags(obj.name)
            obj.name = obj.companyName;
          });
          if (res.data.code === "0") {
            this.tycInfo = JSON.stringify({});
            this.userForm.creditCode = "";
            this.userForm.business = "";
            this.userForm.organizingInstitution = "";
            this.userForm.dutyParagraph = "";
            this.userForm.value1 = [];
            this.userForm.date4 = "";
            this.userForm.date3 = "";
            this.userForm.factCapl = "";
            this.userForm.creditCode = "";
            this.isGAT = false;
            if (res.data.data.length === 0) {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: "info",
                ccuiCustom: true,
              });
            }
            this.supNameList = res.data.data;
            // if(this.supNameList.length==0){
            //   this.userForm.creditCode = ""
            //   this.userForm.business = ""
            //   this.userForm.organizingInstitution = ""
            //   this.userForm.dutyParagraph = ""
            //   this.userForm.value1=[]
            //   this.userForm.date4=""
            //   this.userForm.date3=""
            //   this.userForm.factCapl=""
            //   this.isGAT=false
            //   // this.tycInfo = JSON.stringify({})
            // }
            let results = this.supNameList;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              callback(results);
            }, 100 * Math.random());
          }
        });
      }
    },
    // 选择供应商名称输入的数据
    handleSelect(item) {
      console.log(item);
      if (item) {
        this.userForm.supplierName = item.name;
        qrySupTycInfo({
          companyName: item.name,
          creditCode: item.creditCode,
        }).then((res) => {
          console.log(res);
          if (res.data.code === "0") {
            this.isWhite = res.data.data.isWhite == 1;
            res.data.data = res.data.data.supTycInfoBO;
            this.userForm.creditCode = res.data.data.creditCode;
            this.userForm.business = res.data.data.regNum;
            this.userForm.organizingInstitution = res.data.data.orgCode;
            this.userForm.dutyParagraph = res.data.data.taxCode;
            this.userForm.value1 = [];
            this.userForm.date4 = "";
            this.userForm.date3 = "";
            this.userForm.factCapl = res.data.data.factCapl;
            this.isGAT = false;
            this.$refs.myCascader.inputValue = "";
            // this.tycInfo = {"busiScope":res.data.data.busiScope,"businessEnd":res.data.data.businessEnd,"businessStart":res.data.data.businessStart,"companyType":res.data.data.companyType,"companyTypeName":res.data.data.companyTypeName,"creditCode":res.data.data.creditCode,"factCapl":res.data.data.factCapl,"foundTime":res.data.data.foundTime,
            // "homeAddr":res.data.data.homeAddr,"legalContactName":res.data.data.legalContactName,"moneyType":res.data.data.moneyType,"moneyTypeName":res.data.data.moneyTypeName,"orgCode":res.data.data.orgCode,"regCapl":res.data.data.regCapl,"regNum":res.data.data.regNum,"supName":res.data.data.supName,"supShort":res.data.data.supShort,"taxCode":res.data.data.taxCode}
            this.tycInfo = JSON.stringify(res.data.data);
          }
        });
      }
    },
    ncData(ncData) {
      console.log(
        this.linkmanForm.email !== "",
        this.linkmanForm.userMobile.length > 0,
        "1111"
      );

      if (!(this.linkmanForm.email != "")) {
        this.isEnabled++;
        if (this.Authentication == 0) {
          this.$message.error(
            window.$t("page.applyUsername.inputPlc.contactsEmailMsg")
          );
        } else {
          this.$message.error(
            window.$t("page.applyUsername.inputPlc.contactsMobileMsg")
          );
        }
      } else {
        this.isEnabled = 0;
        this.codeDisabled = false;
      }
    },
    popDialogPay() {
      this.isRecommendedUnitTreeShow = true;
      this.dialogRecommendedUnitTree = true;
    },
    beforeClose() {
      this.isRecommendedUnitTreeShow = false;
      this.dialogRecommendedUnitTree = false;
    },
    closeDialog() {
      this.isRecommendedUnitTreeShow = false;
      this.dialogRecommendedUnitTree = false;
    },
    recommendedUnitLoadNode(node, resolve) {
      if (node.level === 0) {
        queryRecommendedUnitTree({
          parentPartyId: "100001",
        }).then((res) => {
          res.data.data.forEach((e) => {
            e.disabled = true;
          });
          resolve(res.data.data);
        });
      } else {
        queryRecommendedUnitTree({
          parentPartyId: node.data.partyId,
        }).then((res) => {
          res.data.data.forEach((e) => {
            if (e.companyId === "100002") {
              e.disabled = true;
            }
            if (e.companyName == "中国交通建设股份有限公司") {
              e.disabled = true;
            }
          });
          resolve(res.data.data);
        });
      }
      if (node.level > 1) return resolve([]);
    },
    // 获取已选的节点
    getCheckedNodes(data, item) {
      // this.$nexTick(()=>{
      //   if (this.checkedFlag) {
      //     // 通过 keys 设置目前勾选的节点
      //     this.$refs.tree.setCheckedKeys([this.companyId]);
      //   } else {
      //     this.$refs.tree.setCheckedKeys([]);
      //   }
      // })
      if (item.checkedKeys.length == 2) {
        //单选实现
        this.$refs.tree.setCheckedKeys([data.companyId]);
      }
      this.companyId = data.companyId;
      this.linkmanForm.recommendIndyId = data.companyId;
      this.linkmanForm.recommendIndyCode = data.autoCode;
      this.linkmanForm.reCompany = data.companyName;
    },
    // 获取当前被选择的节点
    getCurrentNode(data, check) {
      this.checkedFlag = check;
    },
    confirmForm() {
      if (
        !this.linkmanForm.recommendIndyId ||
        !this.linkmanForm.recommendIndyCode ||
        !this.linkmanForm.reCompany
      ) {
        //弹出提示
        this.$message({
          showClose: true,
          type: "error",
          message: "请重新选择推荐单位",
          ccuiCustom: true,
          duration: 3000,
        });
        return;
      }
      this.closeDialog();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../css/index.scss";
.endItem ::v-deep .el-input__inner {
  padding-right: 58px;
}
.sign-content {
  width: 1180px;
  background: #ffffff;
  margin: 20px auto;
  overflow: hidden;
  position: relative;

  .el-card-title {
    /deep/ .details-title {
      color: black;
      border-bottom: 0px;
      top: 20px;
    }
  }

  .card1 {
    margin-left: 245px;
  }

  .card2 {
    margin-left: 230px;
  }

  .card3 {
    margin-left: 288px;

    &.encard {
      margin-left: 230px;
    }
  }

  .el-form {
    margin-top: 20px;
    //margin-left: 295px;
    position: relative;

    .el-form-item {
      // color: rgba(208, 2, 27, 1);
      .el-col {
        .el-date-editor {
          width: 200px;
        }
      }

      .el-input {
        margin-left: 6px;
        width: 430px;
      }

      .format {
        font-size: 13px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        line-height: 17px;
      }

      /deep/ .el-form-item__label {
        padding: 1px 2px 0 0;
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(74, 74, 74, 1);
      }

      .el-form-item__content {
        margin-left: 90px;
      }
    }

    .el-cascader {
      margin-left: 6px;
      width: 430px;
    }

    .el-radio-group {
      margin-left: 6px;
    }

    .reCompany {
      margin-top: 20px;
    }
  }

  .grouptips {
    width: 340px;
    height: 18px;
    font-size: 13px;
    color: #999;
    font-weight: 400;
    position: absolute;
    top: -38px;
    left: 357px;
    white-space: nowrap;
  }

  .grouptips_en {
    height: 18px;
    font-size: 13px;
    color: #999;
    font-weight: 400;
    //position: absolute;
    //top: -38px;
    //left: 544px;
    white-space: normal;
    margin-bottom: 15px;
    margin-left: 230px;
  }

  .validity .el-col-2 {
    position: absolute;
    left: 220px;
  }

  .validity .el-col-5:nth-child(3) {
    margin-left: 68px;
  }

  .validity .el-date-editor {
    width: 200px;

    /deep/ .el-input__inner {
      width: 200px;
    }
  }

  .authCode {
    position: relative;

    .el-button {
      position: absolute;
      top: 0px;
      left: 450px;
      width: 85px;

      &.enBtn {
        width: 185px;
      }
    }
  }

  .el-autocomplete {
    width: 430px;
    margin-left: 6px;
  }

  .el-block {
    position: absolute;
    top: 30px;
    width: 388px;
    margin-right: 42px;
    height: 30px;
    margin-left: 6px;

    .slideText1 {
      position: absolute;
      z-index: 999;
      left: 138px;
      top: 15px;
    }

    .slideText2 {
      position: absolute;
      z-index: 999;
      left: 188px;
      top: 15px;
      color: #fff;
    }

    .el-block-replace {
      position: absolute;
      width: 42px;
      height: 30px;
      background: #f1f1f1;
      border-radius: 0 3px 3px 0;
      top: 16px;
      right: -42px;
    }
  }

  /deep/ .el-slider {
    .el-slider__runway {
      height: 30px;
      margin-bottom: 15px;
      border-radius: 3px 0 0 3px;
      background-color: #f1f1f1;

      .el-slider__button {
        margin-left: 19px;
        margin-top: 15px;
        width: 40px;
        height: 26px;
        border-radius: 0;
        border: 2px solid #f1f1f1;
      }

      .el-slider__button-wrapper .el-slider__button:hover {
        transform: scale(1);
      }

      .el-slider__bar {
        height: 29px;
        background-color: #00954c;
      }
    }
  }

  .recommendUnitGroup {
    position: relative;

    .reCompanyTitle {
      position: absolute;
      top: 20px;
      left: 357px;
      font-size: 13px;
      color: #999;
    }

    .reCompanyTitle_en {
      //position: absolute;
      //top: 416px;
      //left: 250px;
      //font-size: 13px;
      //color: #FF142F;

      height: 18px;
      font-size: 13px;
      color: #999;
      font-weight: 400;
      margin-top: 20px;
      white-space: normal;
      margin-bottom: 15px;
      margin-left: 230px;
    }
  }
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #ff142f;
  border-color: #ff142f;
}

.el-radio__inner:hover {
  border-color: #ff142f;
}

.btn {
  width: 240px;
  height: 40px;
  background: #ff142f;
  border-color: #ff142f;
  margin-bottom: 20px;

  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}

.btn:hover {
  border-color: #ff142f;
  background: rgba(255, 20, 47, 1);
}

.el-button.el-button--primary-icon-medium.is-active,
.el-button.el-button--primary-icon-medium:active,
.el-button.el-button--primary-icon-medium:focus,
.el-button.el-button--primary-icon-medium:hover {
  border-color: #ff142f;
  background: rgba(255, 20, 47, 1);
}

.btnBox {
  margin: 0px auto;
  width: 500px;
}

/deep/.el-button--primary {
  background: rgba(255, 20, 47, 1);
}

/deep/.el-button--primary:focus {
  background: rgba(255, 20, 47, 1) !important;
}

.disSlide {
  pointer-events: none;
}

/deep/.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #ff142f;
}

/deep/.el-input__inner:focus {
  border-color: #ff142f;
}

/deep/.IDplac input {
  padding-right: 45px;
}

/deep/.enForm {
  height: 496px !important;
}

/deep/.GATcreditCode input {
  padding-right: 50px;
}

/deep/.el-dialog__footer .el-button.el-button--primary-font-mini {
  border-color: #ff142f;
  background: rgba(255, 20, 47, 1) !important;
}
</style>
<style>
.el-cascader-panel .el-radio {
  width: 100% !important;
  height: 100% !important;
  z-index: 10 !important;
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
}

.el-cascader-panel .el-radio__input {
  visibility: hidden !important;
}

.el-cascader-panel .el-cascader-node__postfix {
  top: 10px !important;
}
</style>
